import React, { useEffect, useState, useContext, useCallback } from "react";
import * as api from '../../api/Paid'
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Grid,
    Box,
    Typography,
    Stack,
    Button,
    Container,
    Paper,
    Divider
} from '@mui/material';
import { ProfileContext } from "../../contexts/ProfileContext";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import moment from "moment";
import * as dict from '../../dictionary'
import { BackDropLoading } from "../../ui-component";
import { ModalError } from "../../ui-component";
import { ScriptKbank } from "../../ui-component/ScriptKbank";
import { LoadingContext } from "../../contexts/LoadingContext";
import liff from '@line/liff';
import { checkProductType } from "../../utils/checkProductType";
import { checkPaymentType } from "../../utils/checkPaymentType";
export const Paid = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [order, setOrder] = useState(null)
    const [linkMpayForFeeSummary, setLinkMpayForFeeSummary] = useState(null)
    const [profile, setProfile] = useState(null)
    const [billInfo, setBillInfo] = useState(null)
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [modalError, setModalError] = useState(false);
    const [error, setError] = useState(null);
    const context = useContext(ProfileContext)
    const loadingContext = useContext(LoadingContext)
    const [loading, setLoading] = useState(true)
    const [needFeeSummary, setNeedFeeSummary] = useState(false)
    const [fee, setFee] = useState(0)
    const [custFee, setCustFee] = useState(0)
    const data = location?.state
    const params = new URLSearchParams(location.search);
    const disableCustomerFee = params.get("disableCustomerFee");

    const createOrderForSCBQr = async (data) => {
        const res = await api.createOrderSCBQr(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            setMinutes(10)
            setSeconds(0)
            setOrder(orderData)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    const createOrderForKbankQr = async (data) => {
        const res = await api.createOrderKbankQr(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            setMinutes(10)
            setSeconds(0)
            setOrder(orderData)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    const createOrderFor2c2pQr = async (data) => {
        const res = await api.createOrder2c2pQr(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            if (orderData === null || "") {
                let error = {
                    status: 'เกิดข้อผิดพลาดในการสร้าง QR Code กรุณาลองใหม่อีกครั้ง'
                }
                setError(error)
                setModalError(true)
                setLoading(false)
                return
            }

            // Set countdown to 15 minutes
            setMinutes(15)
            setSeconds(0)
            setOrder(orderData)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    // const createOrderForBillPaymentQr = async (data) => {
    //     const res = await api.createOrderMpayQr(data)
    //     if (res?.status === 200) {
    //         let orderData = res?.data.data
    //         let startTime = moment(orderData?.created_at);
    //         let endTime = moment(orderData?.qr_expire_at);

    //         if ((orderData?.amount_cust_fee > 0 && data?.fee === 0) || data?.amount > orderData?.amount) {
    //             setNeedFeeSummary(true)
    //         }

    //         let duration = moment.duration(endTime.diff(startTime))
    //         setMinutes(parseInt(duration.asMinutes()))
    //         setSeconds(parseInt(duration.asSeconds() % 60))
    //         setOrder(orderData)
    //         setLoading(false)
    //         return
    //     }
    //     setError(res)
    //     setModalError(true)
    //     setLoading(false)
    //     return
    // }


    const createOrderForBillPaymentQr = async (data) => {
        const res = await api.createOrderMpayQr(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            setCustFee(orderData?.amount_cust_fee || 0)
            let startTime = moment(orderData?.created_at);
            let endTime = moment(orderData?.qr_expire_at);
            setNeedFeeSummary(true)
            let duration = moment.duration(endTime.diff(startTime))
            setMinutes(parseInt(duration.asMinutes()))
            setSeconds(parseInt(duration.asSeconds() % 60))
            setOrder(orderData)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    // const checkNeedFeeSummary = (amount_cust_fee, link, mpayAmount, amount) => {
    //     setLinkMpayForFeeSummary(link)
    //     if ((amount_cust_fee > 0 && data?.fee === 0) || amount > mpayAmount) {
    //         setNeedFeeSummary(true)
    //         setLoading(false)
    //         return
    //     }

    //     window.open(link)
    //     setLoading(false)
    //     return
    // }
    const checkNeedFeeSummary = (amount_cust_fee, link, mpayAmount, amount) => {
        setLinkMpayForFeeSummary(link)
        if ((amount_cust_fee > 0 && data?.fee === 0) || amount > mpayAmount) {
            setNeedFeeSummary(true)
            setLoading(false)
            return
        }

        window.open(link)
        setLoading(false)
        return
    }

    const createOrderForMobileBanking = async (data) => {
        const res = await api.createOrderMobileBanking(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            setCustFee(orderData?.amount_cust_fee || 0)
            setLinkMpayForFeeSummary(orderData?.authorize_url)
            setOrder(orderData)
            setNeedFeeSummary(true)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    const createOrderForCreditCard = async (data) => {
        const res = await api.createOrderCreditCard(data)
        if (res?.status === 200) {
            let orderData = res?.data.data
            setCustFee(orderData?.amount_cust_fee || 0)
            setLinkMpayForFeeSummary(orderData?.form_url)
            setOrder(orderData)
            setNeedFeeSummary(true)
            setLoading(false)
            return
        }
        setError(res)
        setModalError(true)
        setLoading(false)
        return
    }

    // const createOrderForMobileBanking = async (data) => {
    //     const res = await api.createOrderMobileBanking(data)
    //     if (res?.status === 200) {
    //         let orderData = res?.data.data
    //         checkNeedFeeSummary(orderData?.amount_cust_fee, orderData?.authorize_url, orderData?.amount, data?.amount)
    //         return
    //     }
    //     setError(res)
    //     setModalError(true)
    //     setLoading(false)
    //     return
    // }

    // const createOrderForCreditCard = async (data) => {
    //     const res = await api.createOrderCreditCard(data)
    //     if (res?.status === 200) {
    //         let orderData = res?.data.data
    //         checkNeedFeeSummary(orderData?.amount_cust_fee, orderData?.form_url, orderData?.amount, data?.amount)
    //         return
    //     }
    //     setError(res)
    //     setModalError(true)
    //     setLoading(false)
    //     return
    // }


    const checkCompanyId = () => {
        let productType = checkProductType()
        if (productType === "rental") {
            return localStorage.getItem("cid_rental")
        }
        if (productType === "pmlite") {
            return localStorage.getItem("cid_pm")
        }
        return localStorage.getItem("cid")
    }


    // const checkIfBePercentCalAnotherWay = () => {

    //     if (billInfo?.fee_type === "Baht") return billInfo?.fee_amount

    //     return (data?.amount * billInfo?.fee_amount) / 100

    // }

    // const checkToShowFeeFromRemORMpay = () => {
    //     if (billInfo?.fee_amount > order?.amount_cust_fee) {
    //         return checkIfBePercentCalAnotherWay()
    //     }
    //     return order?.amount_cust_fee || 0
    // }
    //  const handleDownloadImage = async (imageUrl) => {
    //   try {
    //     // 1) ถ้าเบราว์เซอร์รองรับ Web Share API + share ไฟล์ได้ (iOS 16+/Android ใหม่)
    //     if (navigator.canShare && typeof navigator.canShare === 'function') {
    //       try {
    //         const resp = await fetch(imageUrl, { mode: 'cors', credentials: 'omit' });
    //         if (!resp.ok) throw new Error('fetch fail');
    //         const blob = await resp.blob();
    //         const file = new File([blob], 'qrcode.png', { type: blob.type || 'image/png' });

    //         if (navigator.canShare({ files: [file] })) {
    //           await navigator.share({ files: [file], title: 'QR Code', text: 'บันทึกรูปนี้ไว้เลย' });
    //           return;
    //         }
    //       } catch (_) {
    //         // ตกมาใช้วิธีถัดไป
    //       }
    //     }

    //     // 2) Android/Chrome: ใช้ anchor + download (ต้องมี CORS ที่ S3 ให้ดึง blob ได้)
    //     try {
    //       const resp = await fetch(imageUrl, { mode: 'cors', credentials: 'omit' });
    //       if (!resp.ok) throw new Error('fetch fail');
    //       const blob = await resp.blob();
    //       const url = URL.createObjectURL(blob);
    //       const a = document.createElement('a');
    //       a.href = url;
    //       a.download = 'qrcode.png';
    //       document.body.appendChild(a);
    //       a.click();
    //       a.remove();
    //       URL.revokeObjectURL(url);
    //       return;
    //     } catch (_) {
    //       // ตกไปวิธีสุดท้าย
    //     }

    //     // 3) ไม้ตายสำหรับ iOS/Safari: เปิดลิงก์ที่ "บอกให้ดาวน์โหลด"
    //     // ถ้าทำ presigned URL ไว้ฝั่งเซิร์ฟเวอร์ ให้แนบ response-content-disposition=attachment ได้เลย
    //     // เช่น https://.../13207951.png?response-content-disposition=attachment%3B%20filename%3Dqrcode.png
    //     window.open(imageUrl, '_blank', 'noopener,noreferrer');
    //   } catch (err) {
    //     console.error('ดาวน์โหลดไม่สำเร็จ:', err);
    //     alert('โหลดรูปไม่สำเร็จ ลองใหม่อีกครั้ง');
    //   }
    // };



    const handleRefreshPage = useCallback(() => {
        window.location.reload();
        navigate(location.search, {
            replace: true, state: {
                methodType: "done"
            }
        })
    }, [location.search, navigate])

    // const conditionShowMpay = (type) => {
    //     const { fee } = location?.state
    //     const custFee = order?.custFee || 10
    //     if (fee == 0 && custFee > 0) {
    //         return <LayoutFeeSummary custFee={custFee} />
    //     }
    //     if (type === "qr") {
    //         return <LayoutQrMpay />
    //     }
    //     if (type === "nonQr") {
    //         return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh", p: 5 }}>
    //             <Box sx={{ textAlign: "center" }}>
    //                 <Typography>{dict.AfterPaymentMessage_TXT[profile?.language]}</Typography>
    //                 <Button variant={"contained"} sx={{ mt: 5 }} onClick={() => liff.closeWindow()}>
    //                     {dict.AfterPaymentBtn_TXT[profile?.language]}
    //                 </Button>
    //             </Box>
    //         </Box>
    //     }
    // }

    useEffect(() => {

        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

    }, [context])


    useEffect(() => {
        if (loadingContext?.state?.isLoading === false) {

            // const checkIfBePercentCalAnotherWay = (fee, amount, feeType) => {

            //     if(!fee) return 0

            //     if (feeType === "Baht") return fee

            //     return (amount * fee) / 100

            // }

            const getBill = async () => {

                if (location.state.methodType === "done") {
                    return setLoading(false)
                }

                const data = location?.state
                console.log("data", data)
                const language = context.state?.profile?.customer[0]?.language || "th"
                const billDetail = await api.billPaymentDetail({
                    line_id: data.line_id,
                    contract_id: data.contract_id,
                    load_type: data.load_type,
                    language: language,
                    term_id: data.term_id,
                    reference_id: data.reference_id,
                    reference_type: data.reference_type,
                    product_type: data.product_type,
                    payment_id: data.payment_id !== "undefined" ? data.payment_id : "",
                    payment_type: checkPaymentType()
                })

                setBillInfo(billDetail.data)
                let paramsBill = {
                    company_id: checkCompanyId(),
                    contract_id: billDetail.data.contract_id,
                    amount: data.amount,
                    fee: 0,
                    project_id: billDetail.data.project_id,
                    project_name: billDetail.data.project_name,
                    project_name_eng: billDetail.data.project_name_eng,
                    unit_id: billDetail.data.unit_id,
                    unit_number: billDetail.data.unit_number,
                    customer_id: billDetail.data.customer_id,
                    customer_name: billDetail.data.customer_name,
                    term_id: checkProductType() === "rental" ? billDetail.data.contract_term_id : billDetail.data.term_id,
                    term_name: billDetail.data.term_name,
                    term_name_eng: billDetail.data.term_name_eng,
                    language: language,
                    terms: data.terms
                };

                if (data.methodType === "qr") {

                    return createOrderForBillPaymentQr(paramsBill)

                }
                if (data.methodType === "qr-scb") {
                    return createOrderForSCBQr(paramsBill)
                }

                if (data.methodType === "qr-2c2p") {
                    paramsBill.backendReturnUrl = `${process.env.REACT_APP_2C2P_CALLBACK_BACKEND}/2c2p/payment/postback`
                    paramsBill.frontendReturnUrl = `${process.env.REACT_APP_2C2P_CALLBACK_FRONTEND}/2c2p/order/success`
                    return createOrderFor2c2pQr(paramsBill)
                }

                if (data.methodType === "qr-kbank") {
                    return createOrderForKbankQr(paramsBill)
                }

                if (data.methodType === "mobile-banking") {
                    paramsBill = {
                        ...paramsBill,
                        bank_name: data.choiceSelected
                    }

                    return createOrderForMobileBanking(paramsBill)
                }

                if (data.methodType === "credit") {

                    // let fee = checkIfBePercentCalAnotherWay(billDetail.data.fee_amount, data.amount, billDetail.data.fee_type)
                    // setFee(fee)
                    paramsBill = {
                        ...paramsBill,
                        // fee: fee,
                        // amount: Number(data.amount) + Number(fee),
                        credit_card_type: data.choiceSelected
                    }

                    return createOrderForCreditCard(paramsBill)
                }

            }
            getBill()
        }
    }, [location, loadingContext?.state?.isLoading]);

    useEffect(() => {

        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };

    })

    return <>
        {
            (order !== null && location?.state.methodType === "qr" && needFeeSummary === false) && <>
                <Box sx={{ padding: 2 }}>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{billInfo?.term_name} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(billInfo?.balance)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Amount_Paid_TXT[profile?.language]} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(location.state?.amount)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Fee_Amount_TXT[profile?.language]} : </Typography>
                        {/* <Typography variant={"h6"}>{Number(fee || custFee).toLocaleString()} ฿</Typography> */}
                        <Typography variant={"h6"}>{Number(custFee).toLocaleString()} ฿</Typography>

                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Total_TXT[profile?.language]} : </Typography>
                        {/* <Typography variant={"h6"}>{(Number(data?.amount) + Number(fee || custFee)).toLocaleString()} ฿</Typography> */}
                        <Typography variant={"h6"}>{(Number(data?.amount) + Number(custFee)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"body1"}>{dict.Pay_Within_TXT[profile?.language]} : </Typography>
                        <Typography variant={"body1"}>{billInfo?.invoice_due_date ? moment(billInfo?.invoice_due_date).format("DD/MM/YYYY") : null}</Typography>
                    </Stack>
                    <Grid container sx={{ marginTop: 2 }}>

                        <Grid item xs={12}>
                            <Typography variant={"body1"}>{dict.Scan_To_Paid_TXT[profile?.language]}</Typography>
                        </Grid>

                        <Grid item xs={12}>

                            <Zoom>
                                <div style={{ height: "350px" }}>
                                    <div
                                        role="img"
                                        style={{
                                            background: `url(data:image/jpeg;base64,${order?.qr_img}) no-repeat`,
                                            width: "100%",
                                            height: "100%",
                                            backgroundSize: "contain",
                                            backgroundPosition: "center center"

                                        }} />
                                </div>

                            </Zoom>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ padding: 2 }}>
                    <Stack direction={"row"}>
                        <Box sx={{ wordBreak: "break-all" }}>
                            <Typography variant="caption"> {dict.Transaction_Number_TXT[profile?.language]} : {order?.txn_id}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction={"row"}>
                        <Box sx={{ wordWrap: "break-word" }}>
                            <Typography variant="caption"> {dict.Ref_Number_TXT[profile?.language]} : {order?.order_code}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction={"row"}>
                        <Typography variant="caption"> {dict.Remaining_TXT[profile?.language]} : {minutes} {dict.Minutes_TXT[profile?.language]} {seconds} {dict.Second_TXT[profile?.language]} </Typography>
                    </Stack>
                </Box>
            </>
        }

        {
            (order !== null && location?.state.methodType === "qr-2c2p" && needFeeSummary === false) && <>
                <Box sx={{ padding: 2 }}>
                    {/* 192 version 2 */}
                    {data.terms?.length > 0 ? (
                        data.terms.map((item, index) => (
                            <Stack direction="row" justifyContent={"space-between"} key={index}>
                                <Typography variant={"h6"}>{item[`term_name${profile?.language === "en" ? "_en" : ""}`]} : </Typography>
                                <Typography variant={"h6"}>{(parseInt(item.amount)).toLocaleString()} ฿</Typography>
                            </Stack>
                        ))
                    ) : (
                        <Stack direction="row" justifyContent={"space-between"}>
                            <Typography variant={"h6"}>{billInfo?.term_name} : </Typography>
                            <Typography variant={"h6"}>{(parseInt(billInfo?.balance)).toLocaleString()} ฿</Typography>
                        </Stack>
                    )}
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Amount_Paid_TXT[profile?.language]} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(location.state?.amount)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Total_TXT[profile?.language]} : </Typography>
                        {/* <Typography variant={"h6"}>{(Number(data?.amount) + Number(fee || custFee)).toLocaleString()} ฿</Typography> */}
                        <Typography variant={"h6"}>{(Number(data?.amount) + Number(custFee)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"body1"}>{dict.Pay_Within_TXT[profile?.language]} : </Typography>
                        <Typography variant={"body1"}>{billInfo?.invoice_due_date ? moment(billInfo?.invoice_due_date).format("DD/MM/YYYY") : null}</Typography>
                    </Stack>
                    <Grid container sx={{ marginTop: 2 }}>

                        <Grid item xs={12}>
                            <Typography variant={"body1"}>{dict.Scan_To_Paid_TXT[profile?.language]}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Zoom>
                                <div style={{
                                    height: "450px",
                                    position: "relative",
                                    cursor: "pointer",
                                    border: "3px dashed #4CAF50",
                                    borderRadius: "12px",
                                    padding: "10px",
                                    backgroundColor: "#f0f9f0",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    transition: "all 0.3s ease"
                                }}>
                                    <img
                                        src={order?.response.data}
                                        alt="QR Code - กดค้างเพื่อบันทึก"
                                        title="กดค้างที่รูปเพื่อบันทึก"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            userSelect: "none"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.parentElement.style.transform = "scale(1.02)";
                                            e.currentTarget.parentElement.style.boxShadow = "0 6px 12px rgba(76, 175, 80, 0.3)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.parentElement.style.transform = "scale(1)";
                                            e.currentTarget.parentElement.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                                        }}
                                    />

                                    {/* ข้อความแนะนำลอยอยู่บนรูป */}
                                    <div style={{
                                        position: "absolute",
                                        top: "15px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "rgba(76, 175, 80, 0.95)",
                                        color: "white",
                                        padding: "8px 20px",
                                        borderRadius: "20px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        pointerEvents: "none",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                                        
                                    }}>
                                        {dict.Press_Hold_TXT[profile?.language]}
                                    </div>
                                </div>
                            </Zoom>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ padding: 2 }}>
                    <Stack direction="row" justifyContent="center" alignItems="center" paddingBottom={4}>
                        {/* <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => handleDownloadImage(order?.response.data)}
                            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        >
                            {dict.Download_QR_BTN[profile?.language]}
                        </Button> */}
                    </Stack>

                    <Stack direction="row">
                        <Box sx={{ wordWrap: "break-word" }}>
                            <Typography variant="caption">
                                {dict.Transaction_Number_TXT[profile?.language]} : {order?.transaction?.order_id}
                            </Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row">
                        <Typography variant="caption">
                            {dict.Ref_Number_TXT[profile?.language]} : {order?.transaction?.term_id}
                        </Typography>
                    </Stack>

                    <Stack direction="row">
                        <Typography variant="caption">
                            {dict.Remaining_TXT[profile?.language]} : {minutes} {dict.Minutes_TXT[profile?.language]} {seconds} {dict.Second_TXT[profile?.language]}
                        </Typography>
                    </Stack>
                </Box>

            </>
        }

        {
            (order !== null && location?.state.methodType === "qr-scb") &&
            <>
                <Box sx={{ padding: 2 }}>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{billInfo?.term_name} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(billInfo?.balance)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Amount_Paid_TXT[profile?.language]} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(location.state?.amount)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"body1"}>{dict.Pay_Within_TXT[profile?.language]} : </Typography>
                        <Typography variant={"body1"}>{billInfo?.invoice_due_date ? moment(billInfo?.invoice_due_date).format("DD/MM/YYYY") : null}</Typography>
                    </Stack>
                    <Grid container sx={{ marginTop: 2 }}>

                        <Grid item xs={12}>
                            <Typography variant={"body1"}>{dict.Scan_To_Paid_TXT[profile?.language]}</Typography>
                        </Grid>

                        <Grid item xs={12}>

                            <Zoom>
                                <div style={{ height: "350px" }}>
                                    <div
                                        role="img"
                                        style={{
                                            background: `url(data:image/jpeg;base64,${order?.qr_img}) no-repeat`,
                                            width: "100%",
                                            height: "100%",
                                            backgroundSize: "contain",
                                            backgroundPosition: "center center"

                                        }} />
                                </div>

                            </Zoom>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ padding: 2 }}>
                    {/* <Stack direction={"row"}>
                        <Box sx={{ wordBreak: "break-all" }}>
                            <Typography variant="caption"> {dict.Transaction_Number_TXT[profile?.language]} : {order?.qr.id}</Typography>
                        </Box>
                    </Stack> */}
                    <Stack direction={"row"}>
                        <Box sx={{ wordWrap: "break-word" }}>
                            <Typography variant="caption"> {dict.Ref_Number_TXT[profile?.language]} : {order?.order_code}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction={"row"}>
                        <Typography variant="caption"> {dict.Remaining_TXT[profile?.language]} : {minutes} {dict.Minutes_TXT[profile?.language]} {seconds} {dict.Second_TXT[profile?.language]} </Typography>
                    </Stack>
                </Box>
            </>
        }

        {
            (order !== null && location?.state.methodType === "qr-kbank") &&
            <>
                <Box sx={{ padding: 2 }}>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{billInfo?.term_name} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(billInfo?.balance)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"h6"}>{dict.Amount_Paid_TXT[profile?.language]} : </Typography>
                        <Typography variant={"h6"}>{(parseInt(location.state?.amount)).toLocaleString()} ฿</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Typography variant={"body1"}>{dict.Pay_Within_TXT[profile?.language]} : </Typography>
                        <Typography variant={"body1"}>{billInfo?.invoice_due_date ? moment(billInfo?.invoice_due_date).format("DD/MM/YYYY") : null}</Typography>
                    </Stack>
                    <Grid container sx={{ marginTop: 2 }}>

                        <Grid item xs={12}>
                            <Typography variant={"body1"}>{dict.Scan_To_Paid_TXT[profile?.language]}</Typography>
                        </Grid>

                        <Grid item xs={12}>

                            <Zoom>
                                <div style={{ height: "350px" }}>
                                    <div
                                        role="img"
                                        style={{
                                            background: `url(data:image/jpeg;base64,${order?.qr.image_with_base64}) no-repeat`,
                                            width: "100%",
                                            height: "100%",
                                            backgroundSize: "contain",
                                            backgroundPosition: "center center"

                                        }} />
                                </div>

                            </Zoom>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ padding: 2 }}>
                    <Stack direction={"row"}>
                        <Box sx={{ wordBreak: "break-all" }}>
                            <Typography variant="caption"> {dict.Transaction_Number_TXT[profile?.language]} : {order?.qr.id}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction={"row"}>
                        <Box sx={{ wordWrap: "break-word" }}>
                            <Typography variant="caption"> {dict.Ref_Number_TXT[profile?.language]} : {order?.order_code}</Typography>
                        </Box>
                    </Stack>
                    <Stack direction={"row"}>
                        <Typography variant="caption"> {dict.Remaining_TXT[profile?.language]} : {minutes} {dict.Minutes_TXT[profile?.language]} {seconds} {dict.Second_TXT[profile?.language]} </Typography>
                    </Stack>
                </Box>
            </>
        }

        {
            ((location?.state.methodType !== "qr" && location?.state.methodType !== "qr-kbank" && location?.state.methodType !== "qr-scb" && needFeeSummary === false && loading === false)) &&
            <>

                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh", p: 5 }}>
                    <Box sx={{ textAlign: "center" }}>
                        <Typography>{dict.AfterPaymentMessage_TXT[profile?.language]}</Typography>

                        <Button variant={"contained"} sx={{ mt: 5 }} onClick={() => liff.closeWindow()}>
                            {dict.AfterPaymentBtn_TXT[profile?.language]}
                        </Button>
                    </Box>

                </Box>
            </>
        }

        {
            needFeeSummary === true && <Box sx={{ height: "calc(100vh - 60px)" }}>

                <Container maxWidth="sm" sx={{ minHeight: "100%", paddingTop: 2, paddingBottom: 5 }}>
                    <Paper sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", }} >
                        <Box>
                            <Stack direction={"row"} justifyContent="center">
                                <Box sx={{ width: "100%" }} paddingBottom={3}>

                                    <Stack spacing={1} padding={3}>
                                        <Stack direction={"row"} justifyContent="center">

                                            <Typography fontWeight={"bold"} color="#D34E4E">{dict.Summary_Slip_TXT[profile?.language]}</Typography>
                                        </Stack>

                                        <Stack direction={"row"} justifyContent="space-between">
                                            <Typography variant="subtitle2" color="#000000"> {dict.Project_TXT[profile?.language]} </Typography>
                                            <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {data?.project_name} </Typography>
                                        </Stack>
                                        <Stack direction={"row"} justifyContent="space-between">
                                            <Typography variant="subtitle2" color="#000000"> {checkProductType() === "rental" ? dict.Rental_Unit_TXT[profile?.language] : dict.Unit_TXT[profile?.language]}</Typography>
                                            <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {data?.unit_number} </Typography>
                                        </Stack>
                                        <Stack direction={"row"} justifyContent="space-between">
                                            <Typography variant="subtitle2" color="#000000"> {dict.PayName_TXT[profile?.language]}</Typography>
                                            <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {data?.customer_name} </Typography>
                                        </Stack>

                                    </Stack>
                                    <Divider />
                                    <Stack direction={"row"} justifyContent="space-between" paddingX={3} paddingTop={3}>
                                        <Typography variant="h6" color="#D34E4E" > {dict.Amount_Net_TXT[profile?.language]} </Typography>
                                        <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {(Number(data?.amount)).toLocaleString()} ฿</Typography>
                                    </Stack>
                                    {disableCustomerFee !== 'true' && <Stack direction={"row"} justifyContent="space-between" paddingX={3}>
                                        <Typography variant="h6" color="#D34E4E" > {dict.Fee_Amount_TXT[profile?.language]} </Typography>
                                        {/* <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {fee || custFee} ฿</Typography> */}
                                        <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {custFee} ฿</Typography>

                                    </Stack>}
                                    <Stack direction={"row"} justifyContent="space-between" paddingX={3}>
                                        <Typography variant="h6" color="#D34E4E" > {dict.Total_TXT[profile?.language]} </Typography>
                                        {/* <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {(Number(data?.amount) + Number(fee || custFee)).toLocaleString()} ฿</Typography> */}
                                        <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {disableCustomerFee !== 'true' ? (Number(data?.amount) + Number(custFee)).toLocaleString() : (Number(data?.amount)).toLocaleString()} ฿</Typography>
                                    </Stack>
                                </Box>

                            </Stack>
                        </Box>
                    </Paper>
                    <Button variant={"contained"} sx={{ width: "100%", height: "50px", mt: 2 }} onClick={() => {
                        setNeedFeeSummary(false)
                        if (linkMpayForFeeSummary) {
                            window.open(linkMpayForFeeSummary)
                        }
                    }}>

                        {dict.AcceptBtn_TXT[profile?.language]}
                    </Button>
                    {
                        location?.state.methodType === "qr" && <Stack direction={"row"} mt={2}>
                            <Typography variant="caption"> {dict.Remaining_TXT[profile?.language]} : {minutes} {dict.Minutes_TXT[profile?.language]} {seconds} {dict.Second_TXT[profile?.language]} </Typography>
                        </Stack>
                    }

                </Container>
            </Box>
        }

        {
            (location?.state.methodType === "credit-kbank") &&
            <ScriptKbank
                line_id={location.state?.line_id}
                language={location.state?.language}
                product_type={location.state?.product_type}
                project_id={location.state?.project_id}
                company_id={checkCompanyId()}
                // orderId={order.id}
                customer_id={billInfo?.customer_id}
                contract_id={billInfo?.contract_id}
                unit_id={billInfo?.unit_id}
                term_id={billInfo?.term_id}
                term_name={billInfo?.term_name}
                term_name_eng={billInfo?.term_name_eng}
                project_name={location.state?.project_name}
                method_type={"card"}
                amount={location.state?.amount}
                setStopLoad={() => setLoading(false)}
                refreshPage={handleRefreshPage}
            // onClose={() => setOrder(null)}
            />
        }

        <BackDropLoading
            loading={loading}
        />

        <ModalError
            onClose={() => setModalError(false)}
            open={modalError}
            error={error}
        />
    </>
}
